import { MatSelect } from '@angular/material/select';

export abstract class MultiComboSearchBase {
  abstract mySelect: MatSelect;
  abstract close(): void;
}
